import { type FC } from "react";
import Select from "react-select";
import { Dialog, TriggerButton, TriggerButtonSize } from "widgets";

import { type ColumnAnnotation } from "../../graphql.js";
import { type SelectedDataSeries } from "../../redux/modules/dataset-viewer.js";
import { PopoverController } from "../core/overlays/components/OverlayControllers.js";

interface IDataSeriesPropertiesDialogProps {
  dataSeries?: SelectedDataSeries;
  splitConditions: ColumnAnnotation[];
  handleChangeHidden: (dataSeries: SelectedDataSeries) => void;
  handleSplitConditionSelected: (splitCondition: ColumnAnnotation, dataSeries: SelectedDataSeries) => void;
  // Used for "split all" and contains the split condition string if it is the same for all data series. Otherwise null.
  defaultSplitCondition?: string;
}

const DataSeriesPropertiesDialog: FC<IDataSeriesPropertiesDialogProps> = (props) => {
  // props.defaultSplitCondition is used in the "split all" context, props.dataSeries?.splitByCondition when splitting a specific data series
  const defaultCondition = props.defaultSplitCondition || props.dataSeries?.splitByCondition;

  return (
    <PopoverController
      overlayOptions={{ placement: "bottom" }}
      actionWidget={(controllerProps) => (
        <TriggerButton
          {...controllerProps}
          icon={"settings"}
          size={props.dataSeries ? TriggerButtonSize.Normal : TriggerButtonSize.Small}
          label={props.dataSeries ? "Configure Data Series" : "Configure All Data Series"}
        />
      )}
    >
      {(controllerProps) => (
        <Dialog {...controllerProps} width={240}>
          <label className="control-label">{`Split ${props.dataSeries ? "" : "all "}series by`}</label>
          <Select
            name="splitSeriesBy"
            placeholder={"Select condition"}
            className={"react-select"}
            classNamePrefix={"react-select"}
            isDisabled={false}
            isClearable={true}
            isSearchable={true}
            menuPlacement={props.dataSeries ? "top" : "bottom"}
            options={props.splitConditions || []}
            getOptionLabel={(option: ColumnAnnotation) => option.name}
            getOptionValue={(option: ColumnAnnotation) => option.field}
            onChange={(condition) => props.handleSplitConditionSelected(condition, props.dataSeries)}
            value={props.splitConditions.find((sc: ColumnAnnotation) => sc.field === defaultCondition)}
            noOptionsMessage={() => "No matching condition..."}
            menuPortalTarget={document.body}
          />
        </Dialog>
      )}
    </PopoverController>
  );
};

export { DataSeriesPropertiesDialog };
